// client/src/components/admin/influencer/InfluencerInfoEditModal.js
import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';


function InfluencerInfoEditModal({ open, onClose, influencer, onSuccess }) {
  const [formData, setFormData] = useState({
    userName: '',
    email: '',
    phoneNumber: '',
    userAddress: '',
    marketingOption: false
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open && influencer) {
      setFormData({
        userName: influencer.userName || '',
        email: influencer.email || '',
        phoneNumber: influencer.phoneNumber || '',
        userAddress: influencer.userAddress || '',
        marketingOption: influencer.marketingOption || false
      });
      setError('');
    }
  }, [open, influencer]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // 필드 검증
    if (!formData.userName.trim()) {
      setError('이름을 입력해주세요.');
      return;
    }
    if (!formData.email.trim()) {
      setError('이메일을 입력해주세요.');
      return;
    }
    if (!formData.phoneNumber.trim()) {
      setError('전화번호를 입력해주세요.');
      return;
    }
    if (!formData.userAddress.trim()) {
      setError('주소를 입력해주세요.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/influencer/info/${influencer.userId}/basic`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(formData)
      });

      const data = await res.json();

      if (data.ok) {
        onSuccess();
        onClose();
      } else {
        setError(data.message || '정보 수정에 실패했습니다.');
      }
    } catch (err) {
      console.error('handleSubmit error:', err);
      setError('정보 수정 중 오류가 발생했습니다.');
    }
    setLoading(false);
  };

  if (!open) return null;

  return (
    <div className="influencer-info-edit-modal">
      <div className="influencer-info-edit-modal__content">
        <h2 className="influencer-info-edit-modal__title">
          기본 정보 수정
        </h2>

        {/* 경고 메시지 */}
        <div className="influencer-info-edit-modal__warning">
          <div className="influencer-info-edit-modal__warning-title">⚠️ 주의사항</div>
          <div className="influencer-info-edit-modal__warning-text">
            • 이메일 또는 전화번호 변경 시, 해당 정보로 계정 찾기가 불가능해집니다.<br/>
            • 인플루언서가 로그인 중이라면 다음 로그인 시 변경사항이 반영됩니다.
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          {/* 이름 */}
          <div className="influencer-info-edit-modal__field">
            <label className="influencer-info-edit-modal__label">
              이름 <span className="influencer-info-edit-modal__required">*</span>
            </label>
            <input
              type="text"
              name="userName"
              value={formData.userName}
              onChange={handleChange}
              className="influencer-info-edit-modal__input"
              placeholder="이름을 입력하세요"
            />
          </div>

          {/* 이메일 */}
          <div className="influencer-info-edit-modal__field">
            <label className="influencer-info-edit-modal__label">
              이메일 <span className="influencer-info-edit-modal__required">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="influencer-info-edit-modal__input"
              placeholder="이메일을 입력하세요"
            />
          </div>

          {/* 전화번호 */}
          <div className="influencer-info-edit-modal__field">
            <label className="influencer-info-edit-modal__label">
              전화번호 <span className="influencer-info-edit-modal__required">*</span>
            </label>
            <input
              type="tel"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              className="influencer-info-edit-modal__input"
              placeholder="전화번호를 입력하세요"
            />
          </div>

          {/* 주소 */}
          <div className="influencer-info-edit-modal__field">
            <label className="influencer-info-edit-modal__label">
              주소 <span className="influencer-info-edit-modal__required">*</span>
            </label>
            <input
              type="text"
              name="userAddress"
              value={formData.userAddress}
              onChange={handleChange}
              className="influencer-info-edit-modal__input"
              placeholder="주소를 입력하세요"
            />
          </div>

          {/* 마케팅 수신 동의 */}
          <div className="influencer-info-edit-modal__checkbox-wrapper">
            <label className="influencer-info-edit-modal__checkbox-label">
              <input
                type="checkbox"
                name="marketingOption"
                checked={formData.marketingOption}
                onChange={handleChange}
                className="influencer-info-edit-modal__checkbox"
              />
              <span className="influencer-info-edit-modal__checkbox-text">마케팅 수신 동의</span>
            </label>
          </div>

          {/* 오류 메시지 */}
          {error && (
            <div className="influencer-info-edit-modal__error">
              {error}
            </div>
          )}

          {/* 버튼 */}
          <div className="influencer-info-edit-modal__actions">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="influencer-info-edit-modal__button influencer-info-edit-modal__button--cancel"
            >
              취소
            </button>
            <button
              type="submit"
              disabled={loading}
              className="influencer-info-edit-modal__button influencer-info-edit-modal__button--submit"
            >
              {loading ? '수정 중...' : '수정'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default InfluencerInfoEditModal;

